<script setup lang="ts">
defineProps({ blok: Object });
</script>

<template>
  <section class="relative py-20">
    <div
      class="absolute top-0 left-0 w-full h-[300px] bg-gradient-to-b from-chsc-raw to-transparent z-[-1]"
    />
    <UiContainer max-width="max-w-3xl">
      <header class="insight-category-header">
        <img :src="blok?.icon.filename" :alt="blok?.icon.alt" />
        <StoryblokRichText :doc="blok?.header" />
      </header>
    </UiContainer>
    <UiContainer>
      <div
        class="grid grid-cols-2 gap-x-20 items-center max-[641px]:grid-cols-1 max-[641px]:gap-x-0 max-[641px]:gap-y-10"
      >
        <div
          class="flex flex-col items-center justify-between h-full gap-y-6 px-6 py-6 font-londrina-solid text-chsc-yellow text-center fs-5xl uppercase"
        >
          <img :src="blok?.claim.filename" :alt="blok?.claim.alt" />
        </div>
        <div class="insighr-category-description">
          <StoryblokRichText :doc="blok?.description" />
        </div>
      </div>
    </UiContainer>
    <UiContainer>
      <div
        v-motion-fade-visible-once
        class="insight-li-future mt-20 bg-chsc-indigo-500 rounded-[40px] px-32 py-18 max-[641px]:px-6 max-[641px]:py-12"
      >
        <StoryblokRichText :doc="blok?.future" />
      </div>
    </UiContainer>
    <UiContainer max-width="max-w-3xl">
      <header
        class="mt-20 text-center [&>h4]:text-chsc-indigo-500 [&>h4]:font-londrina-solid [&>h4]:text-center [&>h4]:text-5xl [&>h4]:mb-6 [&>h4>strong]:text-chsc-yellow [&>h4>strong]:font-normal [&>p]:font-eb-garamond [&>p]:text-2xl [&>p]:font-bold"
      >
        <StoryblokRichText :doc="blok?.companies_header" />
      </header>
    </UiContainer>
    <UiContainer max-width="max-w-3xl">
      <div
        class="mt-20 items-center flex flex-col gap-y-10"
      >
        <div class="flex flex-col gap-y-4 items-center justify-center">
          <p class="text-sm font-bold text-center text-chsc-indigo-500">
            {{ blok?.companies_chart_legend }}
          </p>
          <div>
            <ClientOnly>
              <apex-charts
                v-if="blok"
                type="pie"
                width="100%"
                height="300"
                :options="{
                  chart: {
                    type: 'pie',
                  },
                  colors: ['#360086', '#FFC14A', '#9780BC'],
                  stroke: {
                    show: false,
                  },
                  legend: {
                    show: false,
                  },
                  dataLabels: {
                    enabled: true,
                  },
                  tooltip: {
                    enabled: false,
                  },
                  responsive: [
                    {
                      breakpoint: 480,
                      options: {
                        chart: {
                          width: 200,
                        },
                        legend: {
                          position: 'bottom',
                        },
                      },
                    },
                  ],
                }"
                :series="[
                  Number(blok?.companies_chart_yes_number),
                  Number(blok?.companies_chart_no_number),
                  Number(
                    100 -
                      (Number(blok?.companies_chart_yes_number) +
                        Number(blok?.companies_chart_no_number)),
                  ),
                ]"
              />
            </ClientOnly>
          </div>
          <div class="flex items-center justify-center gap-x-4">
            <div class="flex items-center gap-x-2">
              <div class="min-w-[20px] min-h-[20px] bg-chsc-indigo-500 rounded-full" />
              <p class="text-xs font-bold">
                {{ blok?.companies_chart_yes_label }}
              </p>
            </div>
            <div class="flex items-center gap-x-2">
              <div class="min-w-[20px] min-h-[20px] bg-chsc-yellow rounded-full" />
              <p class="text-xs font-bold">
                {{ blok?.companies_chart_no_label }}
              </p>
            </div>
            <div class="flex items-center gap-x-2">
              <div class="min-w-[20px] min-h-[20px] bg-[#9780BC] rounded-full" />
              <p class="text-xs font-bold">
                {{ blok?.companies_chart_unknown_label }}
              </p>
            </div>
          </div>
          <!-- <div
            class="mt-6 uppercase text-center [&>p]:font-londrina-solid [&>p]:text-chsc-yellow [&>p]:text-3xl [&>p]:mb-6 [&>p>strong]:text-chsc-indigo-500"
          >
            <StoryblokRichText :doc="blok?.companies_claim" />
          </div> -->
        </div>
        <div
          class="[&>p]:mb-6 [&>p]:font-eb-garamond [&>p]:text-2xl [&>p>strong]:font-londrina-solid [&>p>strong]:text-chsc-yellow [&>p>strong]:fs-3xl [&>p>strong]:font-normal [&>ol]:mb-6 [&>ol]:font-eb-garamond [&>ol]:text-2xl [&>ol>li>p>strong]:font-londrina-solid [&>ol>li>p>strong]:text-chsc-yellow [&>ol>li>p>strong]:fs-3xl [&>ol>li>p>strong]:font-normal [&>ol]:list-decimal [&>ol]:ml-6"
        >
          <StoryblokRichText :doc="blok?.companies_description" />
        </div>
      </div>
    </UiContainer>
  </section>
</template>
